import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Dropdown from "../../../components/Dropdown";
import BarChart from "./BarChart";
import PerformanceService from "../../../services/performance.service";
import Toaster from "../../../components/toaster";
import Loader from "../../../assets/images/icons/loader.gif";
import FirstTrainingBarChart from "./FirstTrainingBarChart";
import { getPeriodOptions } from "../../../periodOptions";

const Progression = () => {
  const createdAt = useSelector((state) => state.user.user?.createdAt);
  const [selectedOption, setSelectedOption] = useState("Select Game");
  const [selectedOption2, setSelectedOption2] = useState("This Year");
  const [selectedOption3, setSelectedOption3] = useState("score");
  const [selectedUser, setSelectedUser] = useState({
    label: "Select User",
    value: "",
  });
  const [data, setData] = useState([]);
  const [firstTrainingData, setFirstTrainingData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [gameOptions, setGameOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleOptionSelect = (option) => {
    setSelectedOption(option.label);
  };
  const handleOptionSelect2 = (option2) => {
    setSelectedOption2(option2.label);
  };
  const handleOptionSelect3 = (option3) => {
    setSelectedOption3(option3.label);
  };
  const handleUserSelect = (item) => {
    setSelectedUser(item);
  };

  const options = gameOptions;

  const options2 = getPeriodOptions(createdAt);

  const options3 = [
    { label: "Total Score", value: "score" },
    { label: "Hits", value: "hits" },
    { label: "Accuracy", value: "passing" },
  ];

  const getGlobalRanking = async () => {
    setIsLoading(true);
    try {
      if (
        selectedOption !== "Select Game" &&
        selectedOption2 !== "Select" &&
        selectedOption3 !== "Select Score" &&
        selectedUser.label !== "Select User"
      ) {
        const response = await PerformanceService.getPerformance(
          selectedOption !== "Select Game" ? selectedOption : "",
          selectedOption2 !== "Select" ? selectedOption2 : "",
          selectedUser.label !== "Select User" ? selectedUser.value : "",
          selectedOption3 !== "Select Score" ? selectedOption3 : ""
        );

        setData(response.data);
        setFirstTrainingData(response.data.firstTrainingAllMonthAvg);
      }
    } catch (error) {
      Toaster("error", error.message);
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getPlayerByUser = async () => {
    setIsLoading(true);
    try {
      const [playerResponse, gameResponse] = await Promise.all([
        PerformanceService.getPlayerByUser(),
        PerformanceService.getGames(),
      ]);

      const playerData = [
        ...(playerResponse.data.data || []).map((item) => ({
          value: item.playerId,
          label: item.playername,
        })),
      ];

      const gameData = [
        ...(gameResponse.data.data || []).map((item) => ({
          value: item.gameName,
          label: item.gameName,
        })),
      ];

      setUserData(playerData);
      setGameOptions(gameData);
      setSelectedUser(
        playerData[0] || {
          label: "Select User",
          value: "",
        }
      );
      setSelectedOption(gameData[0]?.label || "Select Game");
      setSelectedOption2(options2[3]?.label);
      setSelectedOption3(options3[0]?.value);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPlayerByUser();
  }, []);

  useEffect(() => {
    getGlobalRanking();
  }, [selectedOption, selectedOption2, selectedUser, selectedOption3]);

  return (
    <div>
      {isLoading ? (
        <div className="flex flex-col items-center justify-center mt-5 ">
          <img src={Loader} alt="Loader" className="w-16 h-16" />

          <div className="flex items-center justify-center gap-4 mt-10">
            <Dropdown
              label={selectedUser.label ? selectedUser.label : selectedUser?.label}
              options={userData}
              onSelect={handleUserSelect}
            />
            <Dropdown
              label={selectedOption}
              options={options}
              onSelect={handleOptionSelect}
            />
            <Dropdown
              label={selectedOption2}
              options={options2}
              onSelect={handleOptionSelect2}
            />
            <Dropdown
              label={selectedOption3}
              options={options3}
              onSelect={handleOptionSelect3}
            />
          </div>
        </div>
      ) : (
        <>
          <div className="grid tab:grid-cols-3 w-full gap-4">
            {data != "" && (
              <div className="w-full tab:col-span-2">
                <FirstTrainingBarChart data={firstTrainingData} />
                <div className="border p-4 rounded-lg">
                  <BarChart data={data} selectedOption3={selectedOption3} />
                  <div className="grid tab:flex items-center justify-center gap-4 mt-10">
                    <Dropdown
                      label={
                        selectedUser.label ? selectedUser.label : selectedUser?.label
                      }
                      options={userData}
                      onSelect={handleUserSelect}
                    />
                    <Dropdown
                      label={selectedOption}
                      options={options}
                      onSelect={handleOptionSelect}
                    />
                    <Dropdown
                      label={selectedOption2}
                      options={options2}
                      onSelect={handleOptionSelect2}
                    />
                    <Dropdown
                      label={selectedOption3}
                      options={options3}
                      onSelect={handleOptionSelect3}
                    />
                  </div>
                </div>
              </div>
            )}
            {data != "" && (
              <div className="h-fit tab:col-span-1 grid grid-cols-[repeat(auto-fill,minmax(320px,1fr))] gap-4 text-white">
                <div className="grid gap-3 p-4 rounded-lg border border-white/30 w-full">
                  <h4 className="text-xl">Hits</h4>
                  <h3 className="text-3xl font-semibold">
                    {data?.hitsTotal ? data?.hitsTotal : "--"}
                  </h3>
                </div>
                <div className="grid gap-3 p-4 rounded-lg border border-white/30 w-full">
                  <h4 className="text-xl">Accuracy</h4>
                  <h3 className="text-3xl font-semibold">
                    {data?.passingTotal ? data?.passingTotal : "--"}
                  </h3>
                </div>
                <div className="grid gap-3 p-4 rounded-lg border border-white/30 w-full">
                  <h4 className="text-xl">Total Score</h4>
                  <h3 className="text-3xl font-semibold">
                    {data?.scoreTotal ? data?.scoreTotal : "--"}
                  </h3>
                </div>
                <div className="grid gap-3 p-4 rounded-lg border border-white/30 w-full">
                  <h4 className="text-xl">Most Progression</h4>
                  <h3 className="text-3xl font-semibold">
                    {data?.mostProgression?.scoreAvg
                      ? data?.mostProgression?.scoreAvg
                      : "--"}
                  </h3>
                </div>
                <div className="grid gap-3 p-4 rounded-lg border border-white/30 w-full">
                  <h4 className="text-xl">Highest Score</h4>
                  <h3 className="text-3xl font-semibold">
                    {data.HighestScore ? data.HighestScore : "--"}
                  </h3>
                </div>
              </div>
            )}
          </div>
          {data == "" && (
            <>
              {/*  <p className="flex justify-center text-white py-10 text-xl">
                Data Not Found
              </p> */}
              <div className="flex items-center justify-center gap-4 mt-10">
                <Dropdown
                  label={selectedUser.label ? selectedUser.label : selectedUser?.label}
                  options={userData}
                  onSelect={handleUserSelect}
                />
                <Dropdown
                  label={selectedOption}
                  options={options}
                  onSelect={handleOptionSelect}
                />
                <Dropdown
                  label={selectedOption2}
                  options={options2}
                  onSelect={handleOptionSelect2}
                />
                <Dropdown
                  label={selectedOption3}
                  options={options3}
                  onSelect={handleOptionSelect3}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Progression;
